var _scrollInitWidth = 560;

window._scrollInitWidth = _scrollInitWidth;

var isMacLike = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? true : false;

var customScrollOption = {
	cursorcolor: "#404266",
	cursorwidth: "7px",
	scrollspeed: 70,
	mousescrollstep: 40,
	autohidemode: false
};

const isWidth = function(width, flag){
	if(flag){
		if ($W.width() < width) return true;
		else return false
	}
	else{
		if ($W.width() > width) return true;
		else return false
	}
};

window.isWidth = isWidth;

const initScroll = function(){
	if ( !isMacLike ){
		if (isWidth(_scrollInitWidth, false)) {
			$('html').addClass('init-scroll');
			$('body').niceScroll(customScrollOption);
		}
	}
};

window.initScroll = initScroll;

$(window).on('load',function () {
	initScroll();
});

$('.js-head').on('click', function(){
	setTimeout(function(){
		$("body").getNiceScroll().resize();
	}, 1000);
})
$(function(){
	const $header = $('header');
	const plyrConfig = {playsinline: true, storage: { enabled: false, key: 'plyr' }};

	$('.js-on-visible').viewportChecker();

	$('.js-player').each(function(id, el){
		new Plyr(el, plyrConfig);
	});

	//////
	function setPageClass() {
		if (!$('.webinar-page').length) {
			$('.js-page').css('padding-top', $header.outerHeight(true) + 30);
		}
	}

	setPageClass();

	$W.resize(function(){
		setPageClass();
	});

	//////
	$(window).scroll(function(){
		$(window).scrollTop() > 0 ? $header.addClass('header-shadow') : $header.removeClass('header-shadow')
	});

	//////
	$('.project-single__row--first').find('.project-single__col:last-child .project-single__img').css(
		'margin-top', 0 - $('.project-single__title').outerHeight(true)
	);

	//////
	$(".burger-menu").click(function () {
		$('body').toggleClass('open-mobmenu');
		$(this).toggleClass("menu-on");
	});

  	//////
	var $popup = $('.js-popup');
	var $popupOpenBtn = $('.js-popup-btn');
	var $popupCloseBtn = $('.js-popup-close');
	let playerPopup;


	$popupOpenBtn.click(function () {
		$(this).toggleClass('active');
		var id = $(this).attr('href');
		$popup.not(id).removeClass('popup-show');
		$(id).toggleClass('popup-show');

		if (id === '#popup-video') {
			let urlVideo = $(this).data('url');

			let videoPopup = $('#popup-video .js-popup-player');

			if (urlVideo.indexOf('vimeo') !== -1) {
				videoPopup.attr('data-plyr-provider', 'vimeo');
			} else {
				videoPopup.attr('data-plyr-provider', 'youtube');
			}

			videoPopup.attr('data-plyr-embed-id', urlVideo);

			playerPopup = new Plyr('.js-popup-player', plyrConfig);
		}

		if (!isMacLike) {
			$('body').getNiceScroll().remove();
		}

		if (id === '#popup-stories') {
			var storyIndex = $(this).data('user-index') ? $(this).data('user-index') : 0;
			var sliderIndex = $('[data-user="'+ storyIndex +'"]').first().index();
			var bullet = $('.swiper-pagination-bullet').eq(start);
			activeUser = storyIndex;
			storiesSlider.slideTo(sliderIndex,300);
			storiesSlider.autoplay.start();
			setTimeout(function () {
				bullet.addClass('swiper-pagination-bullet-active');
			},500);
			if(videoArray[sliderIndex]) {
				bullet.css('transition-duration',videoArray[_self.realIndex].duration + 's');
				var videoTimer = setInterval(function () {
					if(videoArray[0].currentTime >= videoArray[0].duration) {
						storiesSlider.slideNext(300);
						storiesSlider.autoplay.stop();
						clearInterval(videoTimer);
					}
				},1000);
			} else {
				bullet.css('transition-duration','5s');
			}
		}
		return false;
	});

	$popupCloseBtn.click(function () {
		$(this).parents('.popup').removeClass('popup-show');
		$popupOpenBtn.removeClass('active');
		initScroll();
		$('#popup-video .js-popup-player').attr('data-plyr-embed-id','');
		playerPopup.destroy();

		if ($B.hasClass('blur')) {
			$B.removeClass('blur');
		}
		if ($H.hasClass('o-hidden')) {
			$H.removeClass('o-hidden');
		}
		if ($('.js-stories-slider').length) {
			pauseAllVideos();
			storiesSlider.autoplay.stop();
		}
	});

	//////
	var fullscreen = false;

	document.addEventListener("webkitfullscreenchange", function (event) {
		if (!fullscreen) {
			$B.addClass('fullscreen-active')
			fullscreen = true;
		}
		else{
			fullscreen = false;
			$B.removeClass('fullscreen-active')
		}
	});

	var $scrolbar = $('.service-tabs__nav');
	var scrollBar = false;

	function initCustomScrollbar() {
		if (isWidth(900, true)) {
			if (!scrollBar) {
				$scrolbar.mCustomScrollbar({
					scrollInertia: 300,
					axis: "x",
					scrollbarPosition: "outside",
					autoHideScrollbar: false
				});
				scrollBar = true
			}
		} else {
			if (scrollBar) {
				$scrolbar.mCustomScrollbar("disable");
				scrollBar = false
			}
		}
	}

	initCustomScrollbar();
	$(window).resize(function () {
		initCustomScrollbar()
	});


	let $scrollto = $('.js-scrollto');
	let h = $('.header').innerHeight() + 80;

	$scrollto.on('click', function(e) {
		e.preventDefault();

		let elementClick = $(this).attr("href");
        let destination = $(elementClick).offset().top - h;

        $("html:not(:animated),body:not(:animated)").animate({
            scrollTop: destination
        }, 500);
    });

});
